import { CustomModal } from "@/components/custom-modal";
import { Button } from "@/components/ui/button";
import {
  DialogClose,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";
import { ToastMessage, type } from "@/lib/toastr";
import {
  changeRole,
  editNotice,
  updateLimit,
} from "@/services/Settings.service";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  ChevronLeft,
  ChevronRight,
  Loader2,
  SquarePen,
  UserPlus,
} from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";

const NoticeActions = ({ data }: any) => {
  const [open, setOpen] = useState(false);
  const queryClient = useQueryClient();
  const [status, setStatus] = useState(data?.status);
  const mutation = useMutation({
    mutationFn: async (payload: unknown) => await editNotice(payload),
    mutationKey: ["notice-update"],
    onSuccess: (res) => {
      console.log(res.data);
      queryClient.invalidateQueries({ queryKey: ["notice"] });
      setOpen(false);
      ToastMessage(type.SUCCESS, "Notice updated successfully");
      // handleDialogItemOpenChange(false);
    },
    onError: (err: any) => {
      ToastMessage(type.ERROR, err.response.data.message);
    },
  });

  const form = useForm();

  const onSubmit = async (formData: any) => {
    const payload = {
      title: formData?.title === undefined ? data?.title : formData?.title,
      content:
        formData?.content === undefined ? data?.content : formData?.content,
      status: formData?.status === undefined ? data?.status : formData?.status,
    };
    console.log(payload, formData);
    await mutation.mutate(payload);
  };

  const handleSwitch = (e: boolean) => {
    const payload = {
      title: data?.title,
      content: data?.content,
      status: e,
    };
    mutation.mutate(payload);
  };

  useEffect(() => {
    setStatus(data?.status);
  }, [data?.status]);
  console.log(data);
  return (
    <div className="flex items-center gap-6">
      <CustomModal
        button={
          // <Button variant='ghost' className="p-0 h-fit bg-transparent hover:bg-transparent"><SquarePenIcon fontSize='2xl' /></Button>
          <Button className="ring-transparent" variant="ghost">
            <SquarePen />
          </Button>
        }
        open={open}
        onOpenChange={setOpen}
        size="sm"
      >
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="flex flex-col gap-8 bg-off-white-1">
              <DialogHeader className="  w-full p-0  bg-off-white-1 py-6 px-8 rounded-t-[16px]">
                <DialogTitle className="text-sm font-normal capitalize text-primary-3">
                  In-app Notice
                </DialogTitle>
                <DialogDescription className="text-sm">
                  Reassign a role to an existing team member
                </DialogDescription>
              </DialogHeader>
              <div className="flex flex-col gap-4 px-8 pb-8 bg-[#F8F7F8]">
                <Label className="pt-0">Message</Label>
                <FormField
                  control={form.control}
                  name="title"
                  render={({ field }) => {
                    return (
                      <FormItem>
                        <div className="flex flex-col w-full items-start gap-1 border-[1px] rounded-[8px] px-2 py-2 h-[52px] border-input-border-2 bg-white">
                          <FormLabel htmlFor="role" className="text-xs">
                            Header Text
                          </FormLabel>

                          <FormControl>
                            <Input
                              className="p-0 border-none bg-transparent rounded-none h-6 w-full "
                              // onChange={(e) => setSelectedAmount(e?.target?.value)}
                              // placeholder="Enter Amount"/
                              // value={selectedAmount === 0 ? "" : selectedAmount}
                              // type='number'
                              defaultValue={data?.title}
                              {...field}
                            />
                          </FormControl>
                        </div>
                      </FormItem>
                    );
                  }}
                />
                <FormField
                  control={form.control}
                  name="content"
                  render={({ field }) => {
                    return (
                      <FormItem>
                        <div className="flex flex-col w-full items-start gap-1 border-[1px] rounded-[8px] px-2 py-2 border-input-border-2 bg-white">
                          <FormLabel htmlFor="role" className="text-xs">
                            Body Text
                          </FormLabel>

                          <FormControl>
                            <div className="flex w-full items-center justify-between gap-3">
                              <Textarea
                                className="p-0 border-none bg-transparent rounded-none w-full h-full focus-visible:ring-0 focus-visible:ring-transparent focus-visible::outline-none focus-visible:border-0 dark:focus-visible:right-0 dark:focus-visible:ring-transparent"
                                // onChange={(e) => setSelectedAmount(e?.target?.value)}
                                // placeholder="Enter Amount"/
                                // value={selectedAmount === 0 ? "" : selectedAmount}
                                // type='number'
                                defaultValue={data?.content}
                                {...field}
                              />

                              {data?.code && (
                                <span className="text-sm text-gray-dark w-fit text-right">
                                  {data?.code?.toLocaleUpperCase()}{" "}
                                  {/* {selectedFee} Fee */}
                                </span>
                              )}
                            </div>
                          </FormControl>
                        </div>
                      </FormItem>
                    );
                  }}
                />
                <div className=" bg-white border-[#E7EAEB] p-2.5">
                  <FormField
                    control={form.control}
                    name="status"
                    render={({ field }) => {
                      return (
                        <FormItem>
                          <div className="flex items-center">
                            <div className="grid">
                              <FormLabel
                                htmlFor="status"
                                className="text-sm font-medium"
                              >
                                Status
                              </FormLabel>
                              <FormDescription className="text-xs">
                                The status determines if the notice is activated
                                or not.
                              </FormDescription>
                            </div>
                            <FormControl>
                              <Switch
                                defaultChecked={data?.status}
                                checked={field.value}
                                onCheckedChange={field.onChange}
                              />
                            </FormControl>
                          </div>
                        </FormItem>
                      );
                    }}
                  />
                </div>
              </div>
            </div>
            <DialogFooter className="px-6 py-4 flex flex-row justify-between items-center bg-off-white-1 rounded-b-[16px]">
              <DialogClose asChild>
                <Button
                  type="button"
                  variant="ghost"
                  className=" text-primary0 h-12 rounded-[10px] p-[8px 12px] hover:text-primary0"
                >
                  <ChevronLeft /> Cancel
                </Button>
              </DialogClose>
              <Button
                type="submit"
                className="bg-gradient-to-r from-primary to-primary-2 h-12 rounded-[10px] p-[8px 12px]"
                disabled={
                  mutation.isPending
                }
              //  !form.formState.isDirty ||
              //   !form.formState.isValid ||
              //   form.formState.isSubmitting ||
              >
                {mutation.isPending && (
                  <Loader2 className="text-white animate-spin" />
                )}
                Save Changes
              </Button>
            </DialogFooter>
          </form>
        </Form>
      </CustomModal>
      <Switch
        checked={status}
        onCheckedChange={(e) => {
          setStatus(e);
          handleSwitch(e);
        }}
      />
    </div>
  );
};

export default NoticeActions;
